import React, { Component } from 'react';
import {connect} from "react-redux";
import AddReportComponent from "./add-report-component";
import {addReportRequest, inputChange, inputError, resetForm} from "./add-report-action-creators";



class AddReportContainer extends Component {

  componentWillUnmount() {
    this.props.resetForm()
  }

  render() {
    return (
      <AddReportComponent
        {...this.props}
      />
    )
  }
}


const mapStateToProps = state => ({
  reportUrl: state.addReport.reportUrl,
  name: state.addReport.name,
  password: state.addReport.password,
  loading: state.addReport.loading,
  error: state.addReport.error
});

const mapDispatchToProps = dispatch => ({
  inputChange: ({ inputValue, inputName }) => dispatch(inputChange({ inputValue, inputName })),
  resetForm: () => dispatch(resetForm()),
  addReport: () => dispatch(addReportRequest()),
});

export default connect(mapStateToProps, mapDispatchToProps)(AddReportContainer);


// WEBPACK FOOTER //
// ./src/modules/add-report/add-report-container.js